import { render, staticRenderFns } from "./section-loading.vue?vue&type=template&id=78760662"
import script from "./section-loading.vue?vue&type=script&lang=js"
export * from "./section-loading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports